import { useScrollReveal } from '@/hooks/useScrollReveal';

const faqs = [
  {
    id: 'data-ownership',
    q: 'Who owns the data?',
    a: 'Your practice does. The workspace and its contents belong to you, in a portable, human-readable structure you can take with you.',
  },
  {
    id: 'where-runs',
    q: 'Where does it run?',
    a: 'Retrieval and your knowledge environment run locally by default. When a task needs outside processing, you see, edit, and approve what is proposed to go out before anything is sent, and the event is recorded.',
  },
  {
    id: 'model-training',
    q: 'Does the model train on our material?',
    a: 'We configure model access so your material is not used for provider training wherever the provider supports it, and we document the configuration for your records. Provider terms are part of the setup review.',
  },
  {
    id: 'clio',
    q: 'Can we use it with Clio?',
    a: 'Soundboard Matter does not replace Clio or your system of record. It works alongside it, and the final record returns to your authoritative system.',
  },
  {
    id: 'stop',
    q: 'What happens if we stop?',
    a: 'You keep your files, your approved-work library, and the records of review and approval. Export and deletion are part of the engagement terms, agreed before work starts.',
  },
  {
    id: 'legal-advice',
    q: 'Do you provide legal advice?',
    a: 'No. Soundboard Matter is not a law firm and does not provide legal advice. Responsibility for professional obligations remains with the licensee.',
  },
];

const LegalFAQ = () => {
  const [ref, isVisible] = useScrollReveal();

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.a,
      },
    })),
  };

  return (
    <section
      ref={ref}
      data-testid="legal-faq-section"
      className={`legal-section section-reveal ${isVisible ? 'visible' : ''}`}
    >
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <div className="legal-content">
        <h2 className="legal-h2" data-testid="legal-faq-h2">
          Frequently asked questions
        </h2>

        <div className="legal-faq-list mt-10">
          {faqs.map((faq) => (
            <div key={faq.id} className="legal-faq-item" data-testid={`legal-faq-${faq.id}`}>
              <h3 className="legal-faq-question">{faq.q}</h3>
              <p className="legal-body mt-3">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LegalFAQ;
